export const PERMISSION_GROUP_KIND_ADMIN = 'admin'
export const PERMISSION_GROUP_KIND_DEFAULT = 'default'
export const PERMISSION_GROUP_KIND = 'kind'
export const PERMISSION_GROUP_KIND_CUSTOM = 'custom'
export const PERMISSION_GROUP_KIND_ONBOARDING = 'onboarding'
